export default __webpack_public_path__ + "static/media/6.3a65436a.png";